import React, { Component} from 'react';
import './Buttons.css'

class ButtonMapa extends Component {

    render() {
        return(
            <button className='btn btn-mapa' type="submit" >VER EN EL MAPA</button>
        )
    }
}

export default ButtonMapa;